export const GET_ARTICLE_LIST = 'home/GET_ARTICLE_LIST'
export const INIT_ARTICLE_LIST = 'home/INIT_ARTICLE_LIST'
export const TOGGLE_BACK_TOP = 'home/TOGGLE_BACK_TOP'
export const RESET_ARTICLE_LIST = 'home/RESET_ARTICLE_LIST'
